// AUTO-GENERATED from environment.mentalplus.production.ts by scripts/select-env.cjs — DO NOT EDIT.
// Edit environment.development.ts (local) or environment.production.ts (prod) instead.
import { StudyDeploymentConfig } from "./study.config";

// MENTAL+ PRODUCTION values (project "mentalplus"). Selected by
// `node scripts/select-env.cjs production --project=mentalplus` (or PROJECT=mentalplus).
// Explicitly the Mental+ deployment; environment.production.ts carries the same
// values and remains the fallback when no project is given.
export const ENV = {
  REACT_APP_BASE_URL: 'https://kastafioreapi.mentalplus.fr',
  VAPID_PUBLIC_KEY: "BP6xaq0wOLB8w368ESw6jWyjKZD7Us5TgtjNdt3_ezpZXhH2DLhOpuXkh3KDnPNn-JavIbbU7HslBopce-XObDw",
  // Bug-report / contact emails sent from the app (ReportBugModal).
  SUPPORT_FROM_EMAIL: 'noreply@mentalplus.fr',
  SUPPORT_TO_EMAILS: ['hosseinjamshidi87@gmail.com'],
  // Brand name (i18n {{appName}} default) + default UI language (html/i18n).
  APP_NAME: 'Mental+',
  DEFAULT_LANG: 'fr',
  // Single-study deployment: study id/slug/is_gamified are known up front, so the app
  // skips the slug -> id welcome lookup and the is_gamified call at bootstrap.
  // For a multi-study deployment use: { mode: 'multi', id: null, slug: null, is_gamified: null }
  STUDY: {
    mode: 'single',
    id: 1,
    slug: 'mentalplus',
    is_gamified: false,
  } as StudyDeploymentConfig,
}
